export default function AboutAwards() {
  const awards = [
    {
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/8b02cbb2fdf9642cec399bcd5abe0eac.jpeg',
      alt: 'Best of Home Care - Provider of Choice 2025'
    },
    {
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/c1d03d1e32396a31eab4f81e73386082.png',
      alt: 'Best of Home Care - Top 100 in Experience 2026'
    },
    {
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/efde94882e19eaa3ceec062be21dfae4.png',
      alt: 'Best of Home Care - Leader in Experience 2026'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-[#5C4F8A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Awards & Recognition
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Honored to be recognized for our commitment to excellence in homecare
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {awards.map((award, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 flex items-center justify-center"
            >
              <img 
                src={award.image}
                alt={award.alt}
                className="w-full h-auto max-h-64 object-contain"
              />
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/90 text-base max-w-3xl mx-auto">
            These awards reflect our team's dedication to providing exceptional care and our commitment 
            to continuously improving the lives of those we serve. We're proud to be recognized as leaders 
            in the homecare industry.
          </p>
        </div>
      </div>
    </section>
  );
}